<template>
  <div v-if="bothSitesExists && !userSelected && !storyblokAdmin.isInStoryblokAdmin() && !route.query.guid" class="B2bB2cSelector">
    <ConfirmModal :show-confirm="false">
      <div class="type-headline-lg mb-16 desk:mb-32">
        {{ $t('b2bb2cSwitch.headline') }}
      </div>
      <div class="flex flex-col gap-16">
        <button class="btn w-full" @click="userSelection('b2b')">
          {{ $t('header.switchTo.b2b') }}
        </button>
        <button class="btn btn--secondary w-full" @click="userSelection('b2c')">
          {{ $t('header.switchTo.b2c') }}
        </button>
      </div>
    </ConfirmModal>
  </div>
</template>

<script setup lang="ts">
import useStatefulCookie from '~/composeables/useStatefulCookie';
import ConfirmModal from '~/components/modals/ConfirmModal.vue';
import useLinkReplacer from '~/composeables/useLinkReplacer';
import { useGlobalContentStore } from '~/store/globalContent';
import useStoryblokAdmin from '~/composeables/useStoryblokAdmin';
const globalContent = useGlobalContentStore();
const storyblokAdmin = useStoryblokAdmin();

const route = useRoute();

const bothSitesExists = globalContent.domainMap?.b2b?.enabled && globalContent.domainMap?.b2c?.enabled;

const userSelected = useStatefulCookie('b2b-b2c-userSelected', { maxAge: 3600 * 24 * 182, path: '/' });
const { replaceLinksInPath } = useLinkReplacer();

const userSelection = (set: string) => {
  const customerType = useStatefulCookie<'b2b'|'b2c'>('customerType', { maxAge: 3600 * 24 * 182, path: '/' });

  console.group();
  let realPathNormalized = replaceLinksInPath(route.path)?.replaceAll('//', '/');

  if (realPathNormalized?.endsWith('/')) {
    realPathNormalized = realPathNormalized.slice(0, -1);
  }

  const paths = route.path.split('/') || [];
  const isProductPage = globalContent.getProductBasePaths.some(s => paths.includes(s));

  const productUrl = paths[paths.length - 1];

  let frontPage = `/${globalContent.domainMap?.storyblokBasePath}/` + (customerType.value === 'b2c' ? globalContent.domainMap?.b2c?.storyblokBasePath : globalContent.domainMap?.b2b?.storyblokBasePath);
  if (frontPage?.endsWith('/')) {
    frontPage = frontPage.slice(0, -1);
  }

  let frontPageOpposite = `/${globalContent.domainMap?.storyblokBasePath}/` + (customerType.value === 'b2c' ? globalContent.domainMap?.b2b?.storyblokBasePath : globalContent.domainMap?.b2c?.storyblokBasePath);
  if (frontPageOpposite?.endsWith('/')) {
    frontPageOpposite = frontPageOpposite.slice(0, -1);
  }

  const productOpposite = customerType.value === 'b2c' ? globalContent.domainMap?.b2b?.productBasePath : globalContent.domainMap?.b2c?.productBasePath;

  let redirect = '';

  console.log('cookie: ' + customerType.value);
  console.log('set: '+ set);
  console.log('frontPage: '+ frontPage);
  console.log('realPathNormalized: '+ realPathNormalized);
  console.log('paths: '+ paths);
  console.log('isProductPage: '+ isProductPage);
  console.log('productUrl: '+ productUrl);
  console.log('frontPageOpposite: '+ frontPageOpposite);
  console.log('productOpposite: '+ productOpposite);

  if ((customerType.value === 'b2c' && set === 'b2b') || (customerType.value === 'b2b' && set === 'b2c')) {
    console.log('should redirect');
    if (realPathNormalized === frontPage) {
      redirect = frontPageOpposite;
      console.log('a');

    } else if (isProductPage) {
      redirect = `/${globalContent.domainMap?.storyblokBasePath}/${productOpposite}/${productUrl}`;
      console.log('b');
    } else {
      redirect = route.path;
      console.log('c');
    }
  } else {
    console.log('should not redirect');
  }

  console.log('redirect: '+redirect);
  console.groupEnd();

  // * * sets the cookie
  userSelected.value = 'true';

  // * * redirect if necessary
  if (redirect !== '') {
    console.log(`${redirect}?forceConsumerType=${set}`);
    window.location.href = `${redirect}?forceConsumerType=${set}`;
  }
};

</script>

<style scoped lang="postcss">
</style>
